import { FunctionComponent, memo, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ConfigContext } from '../../../../context';
import { StoryCardThreadContent } from '../../../../services';
import { HorizontalStoryFeedCardProps, HorizontalStoryFeedContentCommon } from '../../../../shared';
import { HorizontalStoryFeedAdminCardWrapper } from '../HorizontalStoryFeedAdminCardWrapper';

export const HorizontalStoryFeedAdminThread: FunctionComponent<HorizontalStoryFeedCardProps> = memo(
  ({ card }) => {
    const { t } = useTranslation();

    const { localiseKey } = useContext(ConfigContext).config.elements.card.thread;

    const { content, isPinnedToTopOfNewsFeed, isPinnedToTopOfStory } = card;

    const { title } = content as StoryCardThreadContent;

    return (
      <HorizontalStoryFeedAdminCardWrapper card={card}>
        <HorizontalStoryFeedContentCommon
          isPinnedToTopOfNewsFeed={isPinnedToTopOfNewsFeed}
          isPinnedToTopOfStory={isPinnedToTopOfStory}
          source={t(`${localiseKey ?? 'common.discussion'}`)}
          title={title}
        ></HorizontalStoryFeedContentCommon>
      </HorizontalStoryFeedAdminCardWrapper>
    );
  }
);
